import PropTypes from 'prop-types';

const deliveryOptionType = PropTypes.shape({
  key: PropTypes.number,
  type: PropTypes.string,
  timescale: PropTypes.string,
  time_hours: PropTypes.number,
  title: PropTypes.string,
  analytics_id: PropTypes.string,
  code: PropTypes.string,
});

export default deliveryOptionType;
